/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useRef, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Alert from 'react-s-alert';
import { Label, Input, Button, Form } from 'reactstrap';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import DemoService from '../../services/DemoService';
import GeneralService from '../../services/GeneralService';

// local imports
import Message from '../general/Message';
import GeneralNavbar from '../general/GeneralNavbar';

const RequestDemo = props => {

    // contexts
    const { theme, fontFamily, fontSize } = useContext(ThemeContext);
    const { NEXT_APP_URL } = useContext(AuthContext);

    // states
    const [user, setUser] = useState({ firstName: "", lastName: "", email: "", role: "" });
    const [agreeBox, setAgreeBox] = useState(false);
    const [dateBeforeYears, setDateBeforeYears] = useState(moment());
    const [minimumAge, setMinimumAge] = useState(0);
    const [ageBox, setAgeBox] = useState(false);
    const [message, setMessage] = useState({ msgBody: '', msgError: false });
    let timerID = useRef(null);

    useEffect(() => {
        document.getElementById("firstname").focus();
        GeneralService.getMinimumAge().then(data => {
            try {
                setDateBeforeYears(dateBeforeYears.subtract(data.minimumAge, 'years'));
                setMinimumAge(data.minimumAge);
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                GeneralService.logError('at Demo RequestDemo useEffect', 'Error in try catch block', err.stack);
            }
        });
        return () => {
            clearTimeout(timerID)
        }
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [message])

    // Utility functions
    // reset form 
    const resetForm = () => {
        try {
            setUser({ firstName: "", lastName: "", email: "", role: "" });
            setAgreeBox(false);
            setAgeBox(false);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Demo RequestDemo resetForm', 'Error in try catch block', err.stack);
        }
    }

    // handle functions
    const handleChange = e => {
        try {
            setUser({ ...user, [e.target.name]: e.target.value.trim() });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Demo RequestDemo handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            if (!ageBox) {
                setMessage({
                    msgBody: `You must be at least ${minimumAge} years of age as of today`,
                    msgError: true
                })
            } else if (!agreeBox) {
                setMessage({
                    msgBody: "You must agree to terms and policies",
                    msgError: true
                })
            } else {
                DemoService.registerRequest(user).then(data => {
                    const { message } = data;
                    setMessage(message);
                    resetForm();
                    setTimeout(() => props.history.push('/demo/signin'), 3000);
                }).catch(error => {
                    setMessage(error.message)
                })
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Demo RequestDemo handleSubmit', 'Error in try catch block', err.stack);
        }
    }


    // function's return
    return (
        <div>
            <GeneralNavbar history={props.history} />
            <div className="col-md-4 mt-5 mb-5 offset-md-4">
                <div className="p-3" style={theme.form}>
                    <Form onSubmit={handleSubmit} style={{ paddingLeft: "10%", paddingRight: "10%" }}>
                        <h2 id="top" style={theme.heading}>Sign Up for a demo request</h2>
                        <br />

                        {message.msgBody ? <Message message={message} /> : null}

                        <Label htmlFor="firstName" style={theme.formBodyText} >Firstname </Label>
                        <Input type="text"
                            id="firstname"
                            name="firstName"
                            value={user.firstName}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        />
                        <br />

                        <Label htmlFor="lastName" style={theme.formBodyText} >Lastname </Label>
                        <Input type="text"
                            name="lastName"
                            value={user.lastName}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        />
                        <br />

                        <Label htmlFor="email" style={theme.formBodyText} >Email </Label>
                        <Input type="email"
                            name="email"
                            value={user.email}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        />
                        <br />

                        <Label htmlFor="role" style={theme.formBodyText} >Take demo as </Label>
                        <Input type="select"
                            name="role"
                            value={user.role}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        >
                            <option value="">Select one</option>
                            <option value="DemoClient">Client</option>
                            <option value="DemoProvider">Counsellor</option>
                        </Input>
                        <br />

                        <div className="form-check mb-3">
                            <Input className="form-check-Input" type="checkbox" style={{ width: "1rem", height: "1rem" }} id="age" checked={ageBox} onChange={(e) => setAgeBox(e.target.checked)} />
                            <Label className="form-check-Label ml-2" htmlFor="cb4">I am at least {minimumAge} years of age as of today (Date of Birth before {dateBeforeYears.format('DD/MM/YYYY')})</Label>
                        </div>

                        <div className="form-check mb-3">
                            <Input className="form-check-Input" type="checkbox" style={{ width: "1rem", height: "1rem" }} id="agree" checked={agreeBox} onChange={(e) => setAgreeBox(e.target.checked)} />
                            <Label className="form-check-Label ml-2" htmlFor="cb4">I have read and agree to all Terms and Conditions, Privacy Policy, and Cookie Policy (see links below)</Label>
                        </div>

                        <Button className="btn mt-2"
                            type="submit"
                            style={theme.formSubmit}>Submit</Button>

                    </Form>
                </div>

                <div className="text-center" style={{ fontSize: fontSize.sm, fontWeight: 500 }}>
                    <a href={NEXT_APP_URL + '/cookiepolicy'} className="mr-1">Cookie Policy</a>|
                    <a href={NEXT_APP_URL + '/termsconditions'} className="mx-1">Terms  Conditions</a>|
                    <a href={NEXT_APP_URL + '/privacypolicy'} className="mx-1">Privacy Policy</a>
                </div>
            </div>
        </div>
    )


}

export default RequestDemo;